import { z } from 'zod'
import { EmailSchema, NameSchema } from '#app/utils/user-validation.ts'

export type ReportIssueActionResponse = {
	result: Record<string, string[] | null> | null
}

export const ReportIssueSchema = z.object({
	name: NameSchema,
	email: EmailSchema,
	reportUrl: z.string(),
	description: z
		.string({
			error: (issue) =>
				issue.input === undefined ? 'Description is required' : undefined,
		})
		.max(1000, { message: 'Description is too long' }),
})
